if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button.share-button__button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          copyButton: this.querySelector('.share-button__copy'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          emailLink: this.querySelector('[data-share-email]'),
        };

        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        this.titleToShare = this.dataset.shareTitle || document.title;
        this.textToShare = this.dataset.shareText || '';

        this.updateFallbackLinks();

        if (navigator.share && this.elements.shareButton) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', this.share.bind(this));
        } else {
          this.bindFallbackEvents();
        }
      }

      bindFallbackEvents() {
        if (!this.mainDetailsToggle) return;

        this.mainDetailsToggle.addEventListener(
          'toggle',
          this.toggleDetails.bind(this)
        );

        if (this.elements.copyButton) {
          this.elements.copyButton.addEventListener(
            'click',
            this.copyToClipboard.bind(this)
          );
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            'click',
            this.closeFallback.bind(this)
          );
        }
      }

      async share() {
        try {
          await navigator.share({
            title: this.titleToShare,
            text: this.textToShare,
            url: this.urlToShare,
          });
        } catch (error) {
          if (error && error.name === 'AbortError') return;

          this.openFallback();
        }
      }

      openFallback() {
        if (!this.mainDetailsToggle) return;

        this.mainDetailsToggle.removeAttribute('hidden');
        this.bindFallbackEvents();
        this.mainDetailsToggle.open = true;

        if (this.elements.urlInput) {
          window.requestAnimationFrame(() => {
            this.elements.urlInput.focus();
            this.elements.urlInput.select();
          });
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.resetMessage();

          if (this.elements.shareSummary) {
            this.elements.shareSummary.focus();
          }
        }
      }

      async copyToClipboard() {
        let copied = false;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.urlToShare);
            copied = true;
          }
        } catch (error) {
          copied = false;
        }

        if (!copied && this.elements.urlInput) {
          this.elements.urlInput.focus();
          this.elements.urlInput.select();

          try {
            copied = document.execCommand('copy');
          } catch (error) {
            copied = false;
          }
        }

        if (copied) {
          this.showMessage(
            window.accessibilityStrings?.shareSuccess || 'Link kopieret'
          );
        } else {
          this.showMessage('Markér og kopiér linket manuelt');
        }
      }

      closeFallback(event) {
        if (event) event.preventDefault();

        if (!this.mainDetailsToggle) return;

        this.mainDetailsToggle.open = false;
        this.resetMessage();

        if (this.elements.shareSummary) {
          this.elements.shareSummary.focus();
        }
      }

      showMessage(message) {
        if (!this.elements.successMessage) return;

        this.elements.successMessage.textContent = message;
        this.elements.successMessage.classList.remove('hidden');
      }

      resetMessage() {
        if (!this.elements.successMessage) return;

        this.elements.successMessage.textContent = '';
        this.elements.successMessage.classList.add('hidden');
      }

      updateFallbackLinks() {
        if (!this.elements.emailLink) return;

        const subject = encodeURIComponent(this.titleToShare);
        const bodyParts = [];

        if (this.textToShare) {
          bodyParts.push(this.textToShare);
        }

        bodyParts.push(this.urlToShare);

        this.elements.emailLink.href =
          `mailto:?subject=${subject}&body=${encodeURIComponent(bodyParts.join('\n\n'))}`;
      }

      updateUrl(url) {
        this.urlToShare = url || document.location.href;

        if (this.elements.urlInput) {
          this.elements.urlInput.value = this.urlToShare;
        }

        this.updateFallbackLinks();
      }
    }
  );
}
